import { useEffect, useState } from "react";
import { Copy, Users, BadgeDollarSign, Wallet, TrendingUp } from "lucide-react";
import { toast } from "sonner";
import axios, { API } from "@/lib/api";
import LoadingScreen from "@/components/shared/LoadingScreen";

function formatRp(n) { return `Rp ${Number(n || 0).toLocaleString("id-ID")}`; }

export default function AgentDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/agen/dashboard`).then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);

  if (!data) return <LoadingScreen />;

  const link = `${window.location.origin}/register?ref=${data.code}`;

  const copy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Berhasil disalin ke clipboard");
  };

  return (
    <div data-testid="agent-dashboard-page" className="space-y-6">
      <div className="rounded-2xl bg-gradient-to-r from-[#F5B700] to-[#0F6B4F] p-7 text-white">
        <h1 className="font-heading text-2xl font-bold">Assalamu'alaikum, {data.name}</h1>
        <p className="mt-1 text-sm text-white/90">Bagikan kode referral Anda dan dapatkan komisi dari setiap jamaah yang mendaftar.</p>
        <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center">
          <div className="flex items-center gap-2 rounded-full bg-white/15 px-5 py-2.5">
            <span className="font-mono text-lg font-bold tracking-wider" data-testid="agent-referral-code">{data.code}</span>
            <button data-testid="agent-copy-code-button" onClick={() => copy(data.code)} className="rounded-full bg-white/20 p-1.5 hover:bg-white/30"><Copy className="h-3.5 w-3.5" /></button>
          </div>
          <button data-testid="agent-copy-link-button" onClick={() => copy(link)} className="flex items-center gap-2 rounded-full bg-white/15 px-4 py-2.5 text-sm hover:bg-white/25">
            <Copy className="h-3.5 w-3.5" /> Salin Link Referral
          </button>
        </div>
        <p className="mt-2 break-all text-xs text-white/70" data-testid="agent-referral-link">{link}</p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <div className="rounded-2xl bg-white p-5 shadow-[0_2px_10px_rgba(15,107,79,0.05)]" data-testid="agent-stat-total-referred">
          <Users className="h-6 w-6 text-[#0F6B4F]" />
          <p className="mt-3 font-heading text-xl font-bold text-[#1F2937]">{data.total_referred}</p>
          <p className="text-sm text-[#64748B]">Jamaah Direferensikan</p>
        </div>
        <div className="rounded-2xl bg-white p-5 shadow-[0_2px_10px_rgba(15,107,79,0.05)]" data-testid="agent-stat-pending-commission">
          <Wallet className="h-6 w-6 text-amber-500" />
          <p className="mt-3 font-heading text-xl font-bold text-[#1F2937]">{formatRp(data.pending_commission)}</p>
          <p className="text-sm text-[#64748B]">Komisi Menunggu</p>
        </div>
        <div className="rounded-2xl bg-white p-5 shadow-[0_2px_10px_rgba(15,107,79,0.05)]" data-testid="agent-stat-paid-commission">
          <BadgeDollarSign className="h-6 w-6 text-emerald-600" />
          <p className="mt-3 font-heading text-xl font-bold text-[#1F2937]">{formatRp(data.paid_commission)}</p>
          <p className="text-sm text-[#64748B]">Komisi Dibayarkan</p>
        </div>
        <div className="rounded-2xl bg-white p-5 shadow-[0_2px_10px_rgba(15,107,79,0.05)]" data-testid="agent-stat-total-commission">
          <TrendingUp className="h-6 w-6 text-[#F5B700]" />
          <p className="mt-3 font-heading text-xl font-bold text-[#1F2937]">{formatRp(data.total_commission)}</p>
          <p className="text-sm text-[#64748B]">Total Komisi</p>
        </div>
      </div>

      <div className="rounded-2xl border border-amber-100 bg-white p-5 text-sm text-[#64748B]">
        Skema komisi Anda: Fee tetap <span className="font-semibold text-[#1F2937]">{formatRp(data.commission_fixed)}</span> per jamaah + <span className="font-semibold text-[#1F2937]">{data.commission_percentage}%</span> dari nilai tagihan yang lunas dibayar.
      </div>
    </div>
  );
}
